export interface AdminNavItem {
  key: string;
  label: string;
  icon: string;
  path: string;
  /** When set, the module is not built yet and belongs to that development phase. */
  phase?: number;
}

export const ADMIN_NAV: AdminNavItem[] = [
  { key: "dashboard", label: "Resumen", icon: "ri-dashboard-3-line", path: "/admin" },
  { key: "pos", label: "Punto de Venta", icon: "ri-store-2-line", path: "/pos" },
  { key: "branches", label: "Sucursales", icon: "ri-building-2-line", path: "/admin/branches" },
  { key: "users", label: "Usuarios y Permisos", icon: "ri-team-line", path: "/admin/users" },
  { key: "products", label: "Productos", icon: "ri-shopping-bag-3-line", path: "/admin/products" },
  { key: "inventory", label: "Inventario", icon: "ri-stack-line", path: "/admin/inventory" },
  { key: "customers", label: "Clientes y Mayoristas", icon: "ri-user-3-line", path: "/admin/customers" },
  { key: "workshop", label: "Taller y Vehículos", icon: "ri-truck-line", path: "/admin/vehicles" },
  { key: "services", label: "Servicios del Taller", icon: "ri-tools-line", path: "/admin/services" },
  { key: "offers", label: "Ofertas y Descuentos", icon: "ri-price-tag-3-line", path: "/admin/offers" },
  { key: "invoices", label: "Facturación", icon: "ri-receipt-line", path: "/admin/invoices" },
  { key: "settings", label: "Configuración", icon: "ri-settings-3-line", path: "/admin/settings" },
  { key: "cash", label: "Cuadre de Caja", icon: "ri-cash-line", path: "/admin/cash" },
  { key: "profits", label: "Ganancias", icon: "ri-line-chart-line", path: "/admin/profits" },
  { key: "audit", label: "Auditoría", icon: "ri-history-line", path: "/admin/audit" },
];

/** Modules already available (used by the mobile bottom navigation). */
export const ACTIVE_NAV = ADMIN_NAV.filter((item) => !item.phase);